module.exports = __webpack_public_path__ + "img/lemon-left-6.8bee06d9.png";